import React, { useState, useContext, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { Athlete } from './athlete';
import './results.scss';
import { AppContext } from '../../App';
import { dataFetcher } from '../../Utils/dataFetcher';
import { StyledSelect } from '../StyledSelect';
import { ButtonBar } from '../ButtonBar';
import { GAtrack } from '../../Utils/tracking';
// import { secondsInPast } from '../../Utils/time';
import { NoData } from '../NoData';
import { getTrans } from '../../Utils/translate';
import { Spoiler } from '../Spoiler';
import { CosmosText } from '../../cosmos/web-scoped/react';

let timeout;

const Results = ({ config }) => {
  const context = React.useContext(AppContext);
  const uriConfig = context.config.uriConfig;
  const animationControls = useAnimation();
  const [listIndex, setListIndex] = useState(undefined);
  const [lastList, setLastList] = useState(undefined);
  const [loading, setLoading] = useState(true);
  // const [hiddenList, setHiddenList] = useState(undefined);
  const [dataSet, setDataSet] = useState({});
  const [option, setOption] = useState(undefined);
  const [currentLap, setCurrentLap] = useState(undefined);
  const { spoilerResults, setSpoilerResults } = context;
  const { noData, noContent, lastUpdate, lap } = context.lang;

  const appConfig = useContext(AppContext).config;
  const tabOpened = useContext(AppContext).inView;

  const { animation } = appConfig;

  const containerAnimation = {
    hidden: {
      opacity: 1,
      scale: 0,
      transition: {
        duration: animation.duration,
        ease: animation.ease
      }
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        when: 'beforeChildren',
        staggerChildren: 0.1,
        duration: animation.duration,
        ease: animation.ease
      }
    }
  };

  useEffect(() => {
    if (config.hasOwnProperty('uriActiveEvent')) {
      dataFetcher(config.uriActiveEvent).then((data) => {
        if (
          !data.error &&
          data.hasOwnProperty('event') &&
          config.lists.length > 0 &&
          config.lists[0].eventId === data.event.id
        ) {
          setOption(0);
          setLoading(false);
        } else if (
          !data.error &&
          data.hasOwnProperty('event') &&
          config.lists.length > 0 &&
          config.lists[1].eventId === data.event.id
        ) {
          setOption(1);
          setLoading(false);
        } else {
          setOption(0);
          setLoading(false);
        }
      });
    } else {
      setOption(0);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (timeout) {
      clearTimeout(timeout);
    }

    const setData = () => {
      config.lists.forEach(async ({ uri }, index) => {
        let curLap = currentLap;
        let lapuri;

        if (config.lists[index].laps > 1 && !currentLap) {
          for (let lap = config.lists[index].laps; lap >= 1; lap--) {
            const curList = await dataFetcher(uri.replace('{lap}', lap), uriConfig);
            if (curList && curList.results) {
              // rewind lap at minimum results of 20 by default
              if (
                curList.results.length >=
                (config.lists[index].minResultsToRewindLap || 20)
              ) {
                curLap = lap;
                setCurrentLap(lap);
                break;
              }
            }
          }

          if (!curLap) {
            curLap = 1;
            setCurrentLap(1);
          }
        }

        if (curLap) {
          lapuri = uri.replace('{lap}', curLap);
        }

        const data = await dataFetcher(lapuri ? lapuri : uri, uriConfig);

        if (data) {
          setDataSet((dataSet) => {
            let newDataSet = { ...dataSet };
            newDataSet[index] = { ...data };

            // check if athlete already in list
            if (data.results) {
              const checkedData = { ...data };
              checkedData.results = [];
              newDataSet[index].results.forEach((result) => {
                if (checkedData.results.length > 0) {
                  const newAthleteId = result.athlete.id + (result.lap ? result.lap : '');
                  result.athlete.id = newAthleteId;
                  const checkedAtheleteIds = [];

                  checkedData.results.forEach((checkedResult) => {
                    checkedAtheleteIds.push(checkedResult.athlete.id);
                  });
                  if (!checkedAtheleteIds.includes(newAthleteId)) {
                    checkedData.results.push(result);
                  }
                } else {
                  checkedData.results.push(result);
                }
              });
              newDataSet[index] = checkedData;
            }

            if (data && data.status && data.status === 'finished') {
              clearTimeout(timeout);
            }
            animationControls.start('visible');
            return newDataSet;
          });
        }
      });

      timeout = setTimeout(
        setData,
        config.pollRateSeconds ? config.pollRateSeconds * 1000 : 15000
      );
    };

    setData();

    animationControls.start('visible');
  }, [config, animationControls, currentLap, tabOpened, uriConfig]);

  // useEffect(() => {
  //   if (!listIndex && dataSet[0]) {
  //     setLastList(dataSet[0]);
  //     // setHiddenList(
  //     //   dataSet[0] && dataSet[0].results
  //     //     ? dataSet[0].results.filter(
  //     //         ({ result, updated }) =>
  //     //           result.finishing_status === 'finished' &&
  //     //           !secondsInPast(new Date(updated), config.delayDataSeconds || 60)
  //     //       )
  //     //     : undefined
  //     // );
  //     setListIndex(0);
  //   }
  // }, [config, dataSet, listIndex]);

  useEffect(() => {
    if (dataSet[option]) {
      setLastList(dataSet[option]);
      setListIndex(option);
    }
  }, [dataSet, option]);

  const handleChange = (data) => {
    setListIndex(data.value);
    setOption(data);

    const dataLayerArgs = {
      // dataLayer: {
      event: 'rbVideoTracking',
      event_name: 'video_sidebar',
      video_sidebar: {
        value: `Dropdown - ${titles[data.value].label}`,
        widget_type: `Results - ${config.trackingTitle || config.navigationTitle}`
      }
      // eventCategory: 'video',
      // eventAction: 'sidebar'
      // }
    };

    GAtrack(dataLayerArgs);
  };

  const handleChangeButtonBar = (data) => {
    setListIndex(data);
    setOption(data);
    const dataLayerArgs = {
      // dataLayer: {
      event: 'rbVideoTracking',
      event_name: 'video_sidebar',
      video_sidebar: {
        value: `Dropdown - ${titles[data].label}`,
        widget_type: `Results - ${config.trackingTitle || config.navigationTitle}`
      }
      // eventCategory: 'video',
      // eventAction: 'sidebar',
      // }
    };

    GAtrack(dataLayerArgs);
  };

  useEffect(() => {
    const dataLayerArgs = {
      // dataLayer: {
      event: 'rbVideoTracking',
      event_name: 'video_sidebar',
      video_sidebar: {
        value: `Navigation`,
        widget_type: `Results - ${config.trackingTitle || config.navigationTitle}`
      }
      // eventCategory: 'video',
      // eventAction: 'sidebar'
      // }
    };
    console.log('Non sense');
    GAtrack(dataLayerArgs);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);

  const checkShow = () => {
    // console.log(dataSet, !isNaN(listIndex), dataSet[listIndex]);
    return (
      !loading &&
      dataSet &&
      !isNaN(listIndex) &&
      dataSet[listIndex] &&
      dataSet[listIndex].results
    );
  };

  const shallAnimate = (athlete) => {
    if (lastList.lap !== currentLap) return false;

    if (athlete && Boolean(config.advertising) && Boolean(lastList)) {
      const lastListAthlete = lastList.results.find(
        (knownAthlete) => knownAthlete.athlete.id === athlete.athlete.id
      );
      // const hiddenListAthlete = hiddenList.find(
      //   (knownAthlete) => knownAthlete.athlete.id === athlete.athlete.id
      // );
      // const athleteInPast = secondsInPast(
      //   new Date(athlete.updated),
      //   config.delayDataSeconds || 60
      // );

      // if (
      //   hiddenListAthlete &&
      //   athlete.result.finishing_status === 'finished' &&
      //   athleteInPast
      // ) {
      //   return true;
      // }

      if (lastListAthlete && lastListAthlete.result.finishing_status === 'finished')
        return false;
      if (!lastListAthlete) return true;

      return (
        lastListAthlete.result.finishing_status !== 'finished' &&
        athlete.result.finishing_status === 'finished'
      );
    }
  };

  const filterAndSort = (data, listType) => {
    switch (listType.toLowerCase()) {
      case 'start':
        return [...data].sort((a, b) =>
          !a.start.order
            ? 1
            : !b.start.order || a.start.order < b.start.order
            ? -1
            : a.start.order > b.start.order
            ? 1
            : 0
        );

      default:
        /* || status === 'ontrack' /* && secondsInPast(new Date(updated), config.delayDataSeconds || 60))*/
        return [...data]
          .filter(
            ({ status, result, updated }) =>
              (result.rank && (status === 'result' || status === 'lap')) ||
              (result.finishing_status && result.finishing_status !== 'unknown')
          )
          .sort((a, b) => {
            let aRank = a.result.rank;
            let bRank = b.result.rank;
            // if (a.result_changes) {
            //   const aRankChange = a.result_changes.filter(
            //     (change) => change.type === 'rank'
            //   )[0];
            //   if (aRankChange) {
            //     const aChangeInPast = secondsInPast(
            //       new Date(aRankChange.updated),
            //       config.delayDataSeconds || 60
            //     );
            //     aRank = aChangeInPast ? aRankChange.current : aRankChange.previous;
            //   }
            // }
            // if (b.result_changes) {
            //   const bRankChange = b.result_changes.filter(
            //     (change) => change.type === 'rank'
            //   )[0];
            //   if (bRankChange) {
            //     const bChangeInPast = secondsInPast(
            //       new Date(bRankChange.updated),
            //       config.delayDataSeconds || 60
            //     );
            //     bRank = bChangeInPast ? bRankChange.current : bRankChange.previous;
            //   }
            // }
            aRank = parseInt(aRank, 10);
            bRank = parseInt(bRank, 10);
            return !aRank ? 1 : !bRank || aRank < bRank ? -1 : aRank > bRank ? 1 : 0;
          });
    }
  };

  const titles = config.lists.map(({ title }, index) => {
    return { label: title, value: index };
  });

  if (spoilerResults)
    return <Spoiler onClick={() => setSpoilerResults(!spoilerResults)} />;
  return (
    <div className="results">
      {titles.length === 1 ? (
        // if there is just one list make a title
        <h3 className="h3">{getTrans(titles[0].label) || titles[0].label}</h3>
      ) : titles.length > 2 ? (
        // if there are more then two lists use StyledSelect
        <StyledSelect
          className="result-select single"
          options={titles}
          selectFirst
          onChange={handleChange}
          value={option}
          maxHeight={400}
        />
      ) : (
        // if there are just two lists use ButtonBar
        <>
          {!loading && (
            <ButtonBar
              buttons={titles.map((item, index) => {
                return {
                  text: item.label,
                  active: option === item.value || (index === 0 && !option),
                  index: item.value
                };
              })}
              onClick={handleChangeButtonBar}
            />
          )}
        </>
      )}
      {config.lists[listIndex] && config.lists[listIndex].pagination && (
        <div className="appRow">
          <div className={'pagination'}>
            <span
              className={'paginationArrowWrapper'}
              onClick={() => {
                const newLapNum = currentLap >= 2 ? currentLap - 1 : 1;
                setCurrentLap(newLapNum);
              }}
              style={{
                cursor: currentLap < 1 ? 'pointer' : 'default'
              }}
            >
              {currentLap > 1 && <span className={'paginationArrow'}></span>}
            </span>
            <span className={'paginationCurrent'} style={{ textAlign: 'left' }}>
              {getTrans(lap)} {currentLap}
            </span>
            <span
              className={'paginationArrowWrapper'}
              onClick={() => {
                const newLapNum =
                  currentLap <= config.lists[listIndex].laps - 1
                    ? currentLap + 1
                    : config.lists[listIndex].laps;
                setCurrentLap(newLapNum);
              }}
              style={{
                cursor: currentLap < config.lists[listIndex].laps ? 'pointer' : 'default'
              }}
            >
              {currentLap < config.lists[listIndex].laps && (
                <span className={'paginationArrow'}></span>
              )}
            </span>
          </div>
        </div>
      )}
      <div className="appRow full-width">
        <>
          {checkShow() ? (
            <motion.table
              className="table"
              variants={containerAnimation}
              animate={animationControls}
            >
              <tbody>
                {config.lists &&
                  config.lists[listIndex] &&
                  Boolean(config.lists[listIndex].difficultyText) && (
                    <tr>
                      <td className="rank font-mono text-right"></td>
                      {config.showAthleteImage && <td className="athleteImage"></td>}
                      <td className="flag-td"></td>
                      <td className="name"></td>
                      <td className="time text-small difficulty-headline">
                        {getTrans(config.lists[listIndex].difficultyText) || 'Difficulty'}
                      </td>
                    </tr>
                  )}
                {checkShow()
                  ? filterAndSort(
                      dataSet[listIndex].results,
                      config.lists[listIndex].type
                    ).map((athlete, index) => {
                      return (
                        <Athlete
                          start={{ order: index + 1 }}
                          {...athlete}
                          key={`${config.lists[listIndex].type}-${listIndex}-${athlete.athlete.id}`}
                          index={index}
                          animate={shallAnimate(athlete)}
                          advertising={config.advertising}
                          listType={config.lists[listIndex].type || 'result'}
                          delaySeconds={config.delayDataSeconds || 60}
                          pagination={config.lists[listIndex].pagination}
                          useDifficulty={Boolean(config.lists[listIndex].difficultyText)}
                          showAthleteImage={config.showAthleteImage}
                          crosslinkDetails={
                            config.lists[listIndex].crosslinkDetails ||
                            config.crosslinkDetails
                          }
                        />
                      );
                    })
                  : undefined}
              </tbody>
            </motion.table>
          ) : (
            <>
              <NoData noData={getTrans(noData)} noContent={getTrans(noContent)} />
            </>
          )}
        </>
      </div>
      {dataSet &&
      !isNaN(listIndex) &&
      dataSet[listIndex] &&
      dataSet[listIndex].results &&
      dataSet[listIndex].results.length &&
      (dataSet[listIndex].updated_at || dataSet[listIndex].updated) ? (
        <div className="my-8">
          <div className="separator"></div>
          <CosmosText class="mb-2">
            {getTrans(lastUpdate)}:{' '}
            {new Date(
              dataSet[listIndex].updated || dataSet[listIndex].updated_at
            ).toLocaleTimeString()}
          </CosmosText>
        </div>
      ) : undefined}
    </div>
  );
};

export { Results };
